<together-auction-dip-loading [is_loading]="IsLoading"></together-auction-dip-loading>